import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_LCM_PETITION_SIGNATURE_MILESTONE_CONFIG = defineFcm('lcm_petition_signature_milestone_config')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				workflow_id: { type: 'number' },
				list_id: { type: 'number' },
				supported_milestones: {
					type: 'array',
					shape: { type: 'string' },
				},
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'comms-stack',
		context: 'comms_stack',
		description: 'Used to configure petition signature milestones to be sent through Iterable',
		template: {
			workflow_id: 1234,
			list_id: 5678,
			supported_milestones: ['5', '10', '25', '100', '500', '1000', '5000', '10000', '50000'],
		},
	});
